export enum DELIVERY_TYPE {
  DIGITAL = 'digital',
  PRINTED = 'printed',
}

export type DeliveryType = `${DELIVERY_TYPE}`
